<script>
  import * as animateScroll from "svelte-scrollto";
  import { Col, Container, Row } from 'sveltestrap';
</script>

<style>
  .wrapper {
    padding-top: 50px;
    padding-bottom: 25px;
  }

  .text {
    width: 100%;
    text-align: left;
    padding-bottom: 75px;
    /* display: flex; */
  }

  .image {
    padding-right: 0px;
    padding-top: 5px;
  }

  img {
    width: 100%;
    margin-bottom: 75px;
    height: auto;
    max-width: 512px;
  }

  .highlight {
    font-weight: bold;
    padding-bottom: 10px;
    color: var(--palette-pop);
    font-size: 1.2rem;
  }

  .inline {
    display: inline-block;
    padding-bottom: unset;
    font-size: 1rem;
  }

  .rounded {
    border-radius: .75rem !important;
  }

  a {
    cursor:pointer;
    color: var(--palette-pop) !important;
  }

  a:hover {
    color: var(--palette-grad3) !important;
  }

  .outer {
    width: 100%;
    background-color: var(--bgcolor);
    background-image: var(--bgimage);
    position: relative;
  }

  .outer::before {
    background-color: var(--bgcolor);
    content: "";
    position: absolute;
    left: 0; right: 0;
    top: 0; bottom: 0;
  }
</style>

<span id="aboutme"></span>
<div class="outer" style="--bgcolor: white;">
  <Container>
    <Row>
      <Col xs="12">
        <div class="wrapper">
          <div class="handwriting">Who I AM</div>
          <div class="heading">ABOUT ME</div>
        </div>
      </Col>
    </Row>
    <Row>
      <Col lg="5" xs="12">
        <div class="image">
          <img src="/micke4.png" alt="Micael Axestål profile" class="rounded" width="512" height="337">
        </div>
      </Col>
      <Col lg="7" xs="12">
        <div class="text">
          <div class="highlight">Hi there!</div>

          My name is Micael Axestål, a humble <div class="highlight inline">"dalmas"</div> currently residing in the forests outside of <div class="highlight inline">Karlstad</div>, Sweden.
          Besides spending time with my two fantastic little kids and sensational wife, mountain biking (and falling),
          fooling myself I workout regularely, etc, I do spend my <div class="highlight inline">working</div> hours <div class="highlight inline">with</div> anything related to <div class="highlight inline">embedded systems</div>
          as a <div class="highlight inline">consultant</div> helping others through my own company <div class="highlight inline">Copperbyte Solutions</div>.
          And I do like my job...a <div class="highlight inline">LOT</div>!
          <br>
          <br>
          Just scroll down a bit to see what magic powers I posses and some sample projects I have been involved with. If you like
          what <div class="highlight inline">you</div> see and <div class="highlight inline">are in need</div> of exactly just that -
          don't hesitate to <div class="highlight inline"><a on:click={() => animateScroll.scrollToBottom()}>contact me</a></div> and I'm sure we can help each other out!
        </div>
      </Col>
    </Row>
  </Container>
</div>

